import { createContext } from "react";
import { MappedEvent, ResultsFormattedData } from "@data-types/results";

export const ResultsContext = createContext(
	{} as ResultsFormattedData<Map<string, MappedEvent[]>>
);
